import { IModalService } from "angular-ui-bootstrap";

export class CustomFieldModalService {
  public static $inject = ["$uibModal"];

  constructor(private $uibModal: IModalService) {}

  public open(id: string): void {
    this.$uibModal.open({
      templateUrl: require("./views/form.jade"),
      windowClass: "medium-small cf-modal",
      backdropClass: "dark-backdrop",
      controller: "CustomFieldCtrl",
      resolve: {
        paramId: (): string => {
          return id;
        },
      },
    });
  }
}
